export const getLineItemsColumns = (
  hasStatusCanceled,
  showActionsColumn,
  isQtyModified,
  hasCanceledReason
) => {
  let columns = [
    {
      id: "stock_code",
      header: "Stock Code",
      width: 120,
    },
    {
      id: "stock_description",
      header: "Description",
      width: 120,
    },
    {
      id: "bin_bay_location",
      header: "Bin Bay Location",
      width: 120,
    },
    {
      id: "stock_on_hand",
      header: "Stock on Hand",
      width: 120,
      align: "center",
    },
    {
      id: "order_qty",
      header: "Ordered Qty",
      width: 120,
      align: "center",
    },
    {
      id: "modified_qty",
      header: "Modified Qty",
      width: 120,
      align: "center",
    },
    {
      id: "picked_qty",
      header: "Picked Qty",
      width: 120,
      align: "center",
    },
    // Status and Actions columns will be conditionally added below
  ];

  if (hasStatusCanceled) {
    const statusColumn = {
      id: "line_state",
      header: "Status",
      width: 100,
      align: "center",
    };
    columns.push(statusColumn);
  }

  if (showActionsColumn) {
    const actionsColumn = {
      id: "actions",
      header: "Actions",
      width: 100,
      align: "center",
    };
    columns.push(actionsColumn);
  }

  if (isQtyModified) {
    const qtyModifiedColumn = {
      id: "qty_modified_reason",
      header: "Qty Modified Reason",
      width: 120,
    };
    columns.push(qtyModifiedColumn);
  }

  if (hasCanceledReason) {
    const canceledReasonColumn = {
      id: "canceled_reason",
      header: "Canceled Reason",
      width: 120,
    };
    columns.push(canceledReasonColumn);
  }

  return columns;
};
